module.exports = __webpack_public_path__ + "img/fila-2-puzzle-1.e747ad63.png";